'use strict';
const angular = require('angular');

export default angular.module('appApp.tablesortbuttons', [])
  .directive('tablesortbuttons', function() {
    return {
      template: require('./tablesortbuttons.html'),
      restrict: 'EA',
      link: function(scope, element, attrs) {}
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/tablesortbuttons/tablesortbuttons.directive.js